module.exports = __webpack_public_path__ + "img/vector1.ab06b22c.svg";